import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgRemote extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={size} width={size} viewBox="0 0 181.07 300">
                <g fill={color}>
                    <path d="M170.15,0H10.93A10.94,10.94,0,0,0,0,10.93V289.07A10.94,10.94,0,0,0,10.93,300H170.15a10.94,10.94,0,0,0,10.92-10.93V10.93A10.94,10.94,0,0,0,170.15,0Zm-154,283.82V16.18H164.9V283.82ZM1,290.09a10.44,10.44,0,0,0,.4,1.94A10.44,10.44,0,0,1,1,290.09Zm1.15,3.72a10.06,10.06,0,0,0,2.42,2.93A10.06,10.06,0,0,1,2.19,293.81Zm3.18,3.5a10.61,10.61,0,0,0,1.69.92A10.61,10.61,0,0,1,5.37,297.31Zm168.64.92a10.2,10.2,0,0,0,1.69-.92A10.2,10.2,0,0,1,174,298.23Zm2.46-1.49a10,10,0,0,0,2.41-2.93A10,10,0,0,1,176.47,296.74Zm3.16-4.71a9.68,9.68,0,0,0,.4-1.94A9.68,9.68,0,0,1,179.63,292Z" />
                    <rect x="21.25" y="36.13" width="66.02" height="65" rx="12.7" />
                    <rect x="93.81" y="36.13" width="66.02" height="65" rx="12.7" />
                    <rect x="93.81" y="106.13" width="66.02" height="65" rx="12.7" />
                    <rect x="21.25" y="106.13" width="66.02" height="65" rx="12.7" />
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgRemote);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgRemote.js